import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { Showreel } from '../components/Showreel';
import { Manifesto } from '../components/Manifesto';
import { Services } from '../components/Services';
import { Work } from '../components/Work';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { Faq } from '../components/Faq';
import { Footer } from '../components/Footer';
export function Home() {
  const {
    hash
  } = useLocation();
  // Support in-page anchor links arriving from other routes (e.g. Nav on /about).
  useEffect(() => {
    if (!hash) {
      window.scrollTo({
        top: 0
      });
      return;
    }
    const el = document.querySelector(hash);
    if (el) {
      // Wait a frame so the target section is mounted before scrolling.
      requestAnimationFrame(() => el.scrollIntoView({
        behavior: 'smooth'
      }));
    }
  }, [hash]);
  return <main data-id="element-325">
      <Hero data-id="element-326" />
      <Showreel data-id="element-327" />
      <Manifesto data-id="element-328" />
      <Services data-id="element-329" />
      <Work data-id="element-330" />
      <Process data-id="element-331" />
      <Testimonials data-id="element-332" />
      <Pricing data-id="element-333" />
      <Faq data-id="element-334" />
      <Footer data-id="element-335" />
    </main>;
}